import { IContextCategory } from "../types/category.interface";
import { createContext } from "react";

const CategoryScreen = createContext<IContextCategory>({});

export default CategoryScreen;
